
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1159:424)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25 29.476V31h12v-1.524c0-1.01-.395-1.979-1.098-2.694a3.72 3.72 0 00-2.652-1.116h-4.5a3.72 3.72 0 00-2.652 1.116A3.842 3.842 0 0025 29.476zm4.278-5.681a4.444 4.444 0 004.904-.991A4.608 4.608 0 0035.5 19.57a4.609 4.609 0 00-1.318-3.232A4.464 4.464 0 0031 15c-.59 0-1.176.118-1.722.348a4.496 4.496 0 00-1.46.99c-.418.426-.75.93-.976 1.484a4.637 4.637 0 000 3.499c.227.554.558 1.058.976 1.483.418.425.914.76 1.46.99zM19.69 30v-1.75H14V30h5.69zM24 23.875v-1.75H14v1.75h10zm0-6.125V16H14v1.75h10z","fill":"#8200FF"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1159:424","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1159:424"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1159:424","result":"shape"}})])])])
          )
        }
      }
    